import { PhoneCode } from '@common/constants/phone-codes.constant';
import { FullPhone } from '@common/interfaces/full-phone.interface';

export const findLongestSubstring = (codes: PhoneCode[], existingString: string): FullPhone => {
    let longestSubstring = '';
    let resultIndex = -1;
    for (let i = 0; i < codes.length; i++) {
        const currentString = codes[i].phoneCode;
        if (currentString && existingString.startsWith(currentString) && currentString.length > longestSubstring.length) {
            longestSubstring = currentString;
            resultIndex = i;
        }
    }
    let resultData: FullPhone;
    if (resultIndex !== -1) {
        resultData = {
            ...codes[resultIndex],
            phoneNumber: existingString.substring(longestSubstring.length),
        };
    } else {
        resultData = { phoneNumber: existingString.substring(1) };
    }
    return resultData;
};
